function handleImageNode(node) {
  if (!window.liveSocket || !document.contains(node) || !node.onerror) return

  const { setAttribute, removeAttribute } = window.liveSocket.js()

  removeAttribute(node, `onerror`)

  const fallbackSrc = node.dataset.fallbackFailedImages
  if (fallbackSrc) {
    removeAttribute(node, `srcset`)
    setAttribute(node, `src`, fallbackSrc)
  }
}

export default function initFallbackFailedImages() {
  window.fallbackFailedImages ??= []

  window.fallbackFailedImages.forEach(handleImageNode)

  window.fallbackFailedImages.push = function (node) {
    handleImageNode(node)
    return node
  }
}
